import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { isInMobile } from '@fabric-app/compat';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { useExpandedFdocContext } from '../../../../ExpandedFdoc/ExpandedFdocProvider.js';
import { IconLinkWindow } from '@fabric-app/icons/svg';
import { IconPrint } from '@fabric-app/icons/old';

const PDFDropdownItems = () => {
  const { pdf } = useExpandedFdocContext();
  const iframeRef = React__default.useRef(null);
  const onPrint = async () => {
    if (!pdf) {
      return;
    }
    if (!iframeRef.current) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      iframeRef.current = iframe;
    }
    const data = await pdf.getData();
    const blob = new Blob([
      data
    ], {
      type: "application/pdf"
    });
    const objectUrl = window.URL.createObjectURL(blob);
    iframeRef.current.src = objectUrl;
    iframeRef.current.onload = () => {
      try {
        iframeRef.current?.contentWindow?.print();
      } catch (error) {
        console.error("Error printing PDF:", error);
      }
    };
  };
  const onOpenExternal = async () => {
    if (!pdf) {
      return;
    }
    const data = await pdf.getData();
    const blob = new Blob([
      data
    ], {
      type: "application/pdf"
    });
    const objectUrl = window.URL.createObjectURL(blob);
    window.open(objectUrl);
    window.URL.revokeObjectURL(objectUrl);
  };
  return isInMobile() || !pdf ? null : /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(DropdownMenu.Item, {
        onClick: onOpenExternal,
        iconElement: /* @__PURE__ */ jsx(IconLinkWindow, {}),
        children: "Open in browser"
      }),
      /* @__PURE__ */ jsx(DropdownMenu.Item, {
        iconElement: /* @__PURE__ */ jsx(IconPrint, {}),
        onClick: onPrint,
        children: "Print"
      })
    ]
  });
};

export { PDFDropdownItems };
//# sourceMappingURL=PDFDropdownItems.js.map
